<template>
  <b-row align-h="center">
    <b-col style="text-align: -webkit-center">
      <b-card no-body class="preview-img">
        <b-card-body>
          <VueCompareImage class="position-relative" :leftImage="leftImage" :rightImage="rightImage"/>

          <b-tooltip v-if="isMobile" target="edit-btn" variant="danger">{{
              $t('pages.bg_remover.desktop_only')
            }}
          </b-tooltip>
          <b-btn class="edit-btn" id="edit-btn" variant="outline-primary" @click="$emit('showEditor')"
                 :disabled="isMobile">
            <i class="mdi mdi-file-edit"></i>
            {{ $t('pages.bg_remover.edit') }}
          </b-btn>
          <div class="mt-3">
            <b-btn variant="primary" block class="mx-2" @click="$emit('newImage')">
              <i class="fas fa-recycle"></i>
              {{ $t('pages.bg_remover.new_image') }}
            </b-btn>

            <b-btn variant="success" block @click="$emit('downloadImage')">
              <i class="fas fa-save"></i>
              {{ $t('pages.bg_remover.download') }}
            </b-btn>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import VueCompareImage from 'vue-compare-image'
import {isMobile} from 'mobile-device-detect'

export default {
  name: "Show",
  components: {VueCompareImage},
  props: ['leftImage', 'rightImage'],
  data() {
    return {
      isMobile: isMobile
    }
  }
}
</script>

<style scoped>
.preview-img {
  max-width: 600px !important;
}

.edit-btn {
  top: 2em;
  position: absolute;
  right: 2em;
}
</style>